import { Validators } from '@angular/forms';
import { Utils } from '@shared/models/classes/Utils';
import { IApiResponse } from '@shared/models/interfaces/IApiResponse';
import { PMCalendarSelectionMode } from '@shared/models/types/PMCalendarSelectionMode';
import { FormFieldType } from './types/formFieldType';

export interface IFormConfig {
  formLabel?: string;
  sections: IFormSection[];
  rawValues?: boolean;
  autocomplete?: 'on' | 'off';
}

export interface IFormSection {
  groupName: string;
  fields: IFormFieldConfig[];
  validators?: Validators;
  groupLabel?: string | undefined;
  hide?: boolean;
  displayConditions?: IDisplayCondition[]; //| Array<IDisplayCondition[]>
}

export type MapperFunction<T> = (response: IApiResponse<T>) => IOption[];

export interface IFormFieldHint {
  value: string;
  icon?: string;
}

export interface IFormFieldConfig<T = any> {
  type: FormFieldType;
  name: string;
  value?: any;
  label: string;
  placeholder?: string;
  icon?: string;
  disabled?: boolean;
  required?: boolean;
  hideLabel?: boolean;
  hideError?: boolean;
  validators?: Validators;
  asyncValidators?: Validators[];
  cols?: number;
  optionsVariant?: OptionsVariant;
  options?: IOption[];
  dataEndpoint?: string;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  range?: boolean;
  readonly?: boolean;
  autofocus?: boolean;
  pickerType?: PMPickerType;
  data?: any[];
  prefix?: string;
  suffix?: string;
  mask?: boolean;
  loading?: boolean;
  clearable?: boolean;
  readonlyInput?: boolean;
  inlineLabel?: boolean;
  IApiResponseType?: T;
  mapper?: MapperFunction<T>;
  selectionMode?: PMCalendarSelectionMode | undefined;
  multiple?: boolean;
  onEnter?: () => void;
  inline?: boolean;
  minDate?: Date | null | undefined;
  maxDate?: Date | null | undefined;
  displayConditions?: IDisplayCondition[];
  disabledDates?: Date[];
  hint?: IFormFieldHint;
  updateOn?: 'change' | 'blur' | 'submit';
  rows?: number;
  link?: string;
  onlyDigits?: boolean;
}

export interface IOption {
  value: any;
  label?: string;
  htmlLabel?: string;
  description?: string;
  imgSrc?: string;
  attributes?: any;
}

export enum OptionVariantEnum {
  LARGE = 'LARGE',
  COMPACT = 'COMPACT',
}

export type OptionsVariant = `${OptionVariantEnum}`;

export enum ValidationStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
}

export interface IDisplayCondition {
  field: string;
  controlField: string;
  expectedValue?: any;
  watchStatusChanges?: boolean;
  // expectedStatus?: `${FormControlStatus}`;
}

export enum PMPickerTypeEnum {
  DOCTOR_TERM = 'DOCTOR_TERM',
}

export type PMPickerType = `${PMPickerTypeEnum}`;

export function DefaultMapper(response: IApiResponse<any>) {
  const opts = [...response.content].map((res) => {
    return {
      value: res.id,
      label: Utils.getTranslation(res.name),
      description: Utils.getTranslation(res.description),
      imgSrc: res?.img,
    } as IOption;
  });
  return opts;
}
